import { getContentURL, getSiteBaseURL } from "../ContentAPI";
import { getConvertedVideoUrl } from "./VideoUtils";
/**
 * Generates Open Graph meta data for a post
 */
export function generatePostOpenGraphData(post, channelOwnerId, channelId, postId) {
    const baseUrl = getSiteBaseURL();
    const contentUrl = getContentURL();
    // Generate the post URL
    const postUrl = `${baseUrl}PostView?channelOwnerId=${channelOwnerId}&channelId=${channelId}&postId=${postId}`;
    // Generate title - use post title if available, otherwise create a default
    const title = post.title ||
        (post.hasVideo
            ? "Video Post on MediaShare.Link"
            : post.hasImage
                ? "Image Post on MediaShare.Link"
                : "Post on MediaShare.Link");
    // Generate description - use post text if available, otherwise create a default
    const description = post.text ||
        (post.hasVideo
            ? "Watch this video shared on MediaShare.Link"
            : post.hasImage
                ? "View this image shared on MediaShare.Link"
                : "Check out this post on MediaShare.Link");
    // Determine content type
    let type = "article";
    if (post.hasVideo) {
        type = "video.other";
    }
    else if (post.hasImage || post.text) {
        type = "article";
    }
    else {
        type = "website";
    }
    // Generate image URL - use post image or video thumbnail if available
    let imageUrl = `${baseUrl}img/shareicon.png`; // Default fallback image
    if (post.hasVideo) {
        // For videos, try to use the thumbnail (MediaConvert adds frame number)
        imageUrl = `${contentUrl}/u/${channelOwnerId}/${channelId}/${postId}.thumb.0000000.jpg`;
    }
    else if (post.hasImage) {
        // For images, use the actual image
        imageUrl = `${contentUrl}/u/${channelOwnerId}/${channelId}/${postId}.jpg`;
    }
    // Generate video URL and type if it's a video post
    let videoUrl;
    let videoType;
    if (post.hasVideo) {
        // Use HLS manifest URL for better compatibility with social media platforms
        const originalVideoUrl = `u/${channelOwnerId}/${channelId}/${postId}.mp4`;
        const hlsUrl = getConvertedVideoUrl(originalVideoUrl);
        videoUrl = `${contentUrl}/${hlsUrl}`;
        videoType = "application/x-mpegURL"; // HLS MIME type
    }
    return {
        title,
        description,
        type,
        url: postUrl,
        image: imageUrl,
        videoUrl,
        videoType,
        siteName: "MediaShare.Link",
    };
}
/**
 * Generates Open Graph meta data for a channel
 */
export function generateChannelOpenGraphData(channelData, channelOwnerId, channelId) {
    const baseUrl = getSiteBaseURL();
    const contentUrl = getContentURL();
    // Generate the channel URL
    const channelUrl = `${baseUrl}ChannelView?channelOwnerId=${channelOwnerId}&channelId=${channelId}`;
    // Generate title - use channel title
    const title = channelData.title || "Channel on MediaShare.Link";
    // Generate description - use channel description, subtitle, or create a default
    let description = channelData.description;
    if (!description && channelData.subtitle) {
        description = channelData.subtitle;
    }
    if (!description) {
        description = `Check out this channel on MediaShare.Link`;
    }
    // Truncate description if it's too long
    description = truncateText(description, 160);
    // Channels are typically "website" type
    const type = "website";
    // Generate image URL - use channel image, fallback to default if not available
    const imageUrl = `${contentUrl}/u/${channelOwnerId}/${channelId}/channel.jpg`;
    return {
        title,
        description,
        type,
        url: channelUrl,
        image: imageUrl,
        siteName: "MediaShare.Link",
    };
}
/**
 * Truncates text to a specified length for meta descriptions
 */
export function truncateText(text, maxLength = 160) {
    if (text.length <= maxLength) {
        return text;
    }
    // Find the last space before the max length to avoid cutting words
    const truncated = text.substring(0, maxLength);
    const lastSpace = truncated.lastIndexOf(" ");
    if (lastSpace > 0) {
        return truncated.substring(0, lastSpace) + "...";
    }
    return truncated + "...";
}
